<template>
  <v-dialog v-model="dialogOpen" width="1000" @click:outside="close">
    <v-card>

      <v-card-title>Create Ticket</v-card-title>

      <v-card-text class="pb-4">
        <v-row>
          <v-col cols="12" md="6" class="py-0">

            <v-row>
              <v-col>
                <v-select label="Ticket type" v-model="kind" :items="getTicketTypes" dense :class="`${(kindErrors.length===0)?'':'mb-n5'}`" :hide-details="kindErrors.length===0" outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" @change="$v.kind.$touch()" @blur="$v.kind.$touch()" :error-messages="kindErrors"></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-autocomplete label="Agent" v-model="agent" :items="getCrmUsersForSelect" dense  :hide-details="true" outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading"></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select label="Department" v-model="team" :items="getTicketTeams" dense :class="`${(teamErrors.length===0)?'':'mb-n5'}`" :hide-details="teamErrors.length===0" outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" @change="$v.team.$touch()" @blur="$v.team.$touch()" :error-messages="teamErrors"></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-autocomplete label="Escalation Agent" v-model="escalation_agent" :items="getCrmUsersForSelect" dense hide-details outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading"></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field label="Callback Number" v-model="callback_number" dense hide-details outlined :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <DateTimePicker label="Next follow up date" ref="dateTimePicker" :pdt="next_follow_up_date" @set-datetime="setDatetime" :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" :dateToday="todaysDate" />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field label="Supplier Ticket ID" v-model="supplier_ticket_id" dense :hide-details="!$v.supplier_ticket_id.$invalid" outlined :error-messages="supplierIdErrors" :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" @blur="$v.supplier_ticket_id.$touch()" @input="$v.supplier_ticket_id.$touch()"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6" class="py-0">
            <v-row>
              <v-col>
                <v-text-field label="Ticket Summary" v-model="summary" dense outlined :hide-details="!$v.summary.$invalid" :error-messages="summaryErrors" :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading" @blur="$v.summary.$touch()" @input="$v.summary.$touch()"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-textarea v-model="description" label="Description" height="360px" placeholder dense outlined hide-details :disabled="ticketUpdateLoading||crmUsersLoading" :loading="crmUsersLoading"></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small :loading="getTicketUpdateLoading" @click="submit">CREATE</v-btn>
        <v-btn color="primary" small :disabled="getTicketUpdateLoading" outlined @click="close">CANCEL</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required, maxLength } from "vuelidate/lib/validators";
  import { mapActions, mapGetters, mapState } from 'vuex';
  import moment from 'moment';
  import { formatDateToUTC } from '@/helpers';

  import DateTimePicker from '@/components/Globals/DateTimePicker';

  export default {
    components: {DateTimePicker},

    mixins: [ validationMixin ],

    validations: {
      kind: { required },
      team: { required },
      supplier_ticket_id: { maxLength: maxLength(256) },
      summary: { maxLength: maxLength(140) },
    },

    data() {
      return {
        kind: '',
        agent: '',
        team: '',
        escalation_agent: '',
        callback_number: '',
        next_follow_up_date: null,
        todaysDate: moment(new Date()).format('YYYY-MM-DD'),
        description: '',
        supplier_ticket_id: null,
        summary: null,
      }
    },

    computed: {
      ...mapGetters('crmUsers',['getCrmUsersForSelect']),
      ...mapState('crmUsers',['crmUsersLoading']),
      ...mapState('tickets',['currentTicket','ticketUpdateLoading','newTicketID']),
      ...mapGetters('tickets',['getTicketTeams','getTicketTypes','getTicketUpdateLoading']),

      kindErrors() {
        const errors = [];
        if (!this.$v.kind.$dirty) return errors;
        !this.$v.kind.required && errors.push("Type is required");
        return errors;
      },

      teamErrors() {
        const errors = [];
        if (!this.$v.team.$dirty) return errors;
        !this.$v.team.required && errors.push("Team is required");
        return errors;
      },

      summaryErrors() {
        const errors = [];
        if (!this.$v.summary.$dirty) return errors;
        !this.$v.summary.maxLength && errors.push("Maximum character length of summary field is 140");
        return errors;
      },

      supplierIdErrors() {
        const errors = [];
        if (!this.$v.supplier_ticket_id.$dirty) return errors;
        !this.$v.supplier_ticket_id.maxLength && errors.push("Maximum character length of supplier id field is 256");
        return errors;
      },
    },

    props: ['dialogOpen'],

    watch: {
      async dialogOpen(open) {
        if(open){
          await this.fetchCRMUsers();
        }
      }
    },

    methods: {
      ...mapActions('crmUsers',['fetchCRMUsers']),
      ...mapActions('tickets',['createNewTicket']),

      setDatetime(datetime){
        this.next_follow_up_date = datetime;
      },

      async submit() {
        this.$v.$touch();
        if(!this.$v.$error){
          let data = {
            kind: this.kind,
            agent: this.agent,
            team: this.team,
            escalation_agent: this.escalation_agent,
            callback_number: this.callback_number,
            next_follow_up_date: (this.next_follow_up_date!==null&&this.next_follow_up_date!=='')?formatDateToUTC(this.next_follow_up_date):null,
            description: this.description,
            supplier_ticket_id: this.supplier_ticket_id,
            summary: this.summary,

          }
          let success = await this.createNewTicket({pid:this.$route.params.id,data:data});
          if(success){
            this.close();
            this.$router.push(`/tickets/${this.newTicketID}/`);
          }
        }
      },
      
      close() {
        this.$v.$reset();
        this.$refs.dateTimePicker.resetDateTimePicker();
        this.kind = '';
        this.agent = '';
        this.team = '';
        this.escalation_agent = '';
        this.callback_number = '';
        this.next_follow_up_date = null;
        this.description = '';
        this.summary = '';
        this.supplier_ticket_id = '';
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
